export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classement magasins"])},
        "store_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasin"])},
        "compliance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conformité"])},
        "total_reward": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gains"])},
        "show_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir le classement réseau"])},
        "show_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir moins"])},
        "network_rank": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["réseau"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store ranking"])},
        "store_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store"])},
        "compliance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compliance"])},
        "total_reward": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rewards"])},
        "show_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View network ranking"])},
        "show_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show less"])},
        "network_rank": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["network"])}
      }
    }
  })
}
